
<div id="main-wrapper">
  <div class="site-wrapper-reveal">
      <div class="position-relative w-100">
          <div class="d-flex align-items-center h-100 w-100">

              <!-- "> md" -->
              <img src="../../../assets/images/banners/new-contactbanner.png"
                  class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="contact-banner-mit" />

              <!-- "<= md" -->
              <img src="../../../assets/images/banners/contact-mobileimage.png"
                  class="img img-responsive d-block d-md-none" width="100%" alt="contact-mobile-view-banner-mit" />

              <div class="position-absolute w-100 home-banner">
                  <div class="row h-100 w-100">
                      <div class="col-8 col-md-5 col-sm-6 banner-section">
                          <div class="align-items-center banner-content-title global_title global_banner_title">
                              <span>Connect with us </span>
                          </div>
                          <div class="global_sub_title global_banner_subtitle mt-3">
                              <span>Discover the best digital opportunities for your business.</span>
                          </div>

                      </div>
                  </div>
              </div>
          </div>
      </div>
      
  </div>
      
  <div class="contact-us-section-wrapper section-space--pt_100 section-space--pb_70">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="contact-form-wrap">
            <form [formGroup]="contactForm" id="contactForm" (ngSubmit)="onSubmit()">
              <div class="contact-form">
                <div class="contact-input">
                  <div class="contact-inner">
                    <label for="contact_Name" hidden>Full name</label>
                    <input name="contactName" formControlName="contactName" type="text" placeholder="Full Name*" minlength="2" maxlength="30" />
                    <div *ngIf="contactForm.get('contactName')?.invalid && contactForm.get('contactName')?.touched" id="contact_NameError" style="font-size: 13px; color: #FF0000; font-style: italic; 
                            font-weight: 500; display: flex;">
                      {{ contactNameError }}
                    </div>
                  </div>
                  <div class="contact-inner">
                    <label for="contact_Email" hidden>Email</label>
                    <input name="contactEmail" formControlName="contactEmail" type="email" placeholder="Email*" />
                    <div *ngIf="contactForm.get('contactEmail')?.invalid && contactForm.get('contactEmail')?.touched" id="contact_emailError" style="font-size: 13px; color: #FF0000; font-style: italic; font-weight: 500;display: flex;">
                      {{ contactEmailError }}
                    </div>
                  </div>
                </div>   
<!--<div class="contact-inner row">
 <div class="col-md-3">
<select formControlName="country" id="country-code" class="form-control" aria-required="true" aria-invalid="false">
<option [value]="country.dialCode">
  {{ country.code }} ({{ country.dialCode }})
</option>
</select>
</div>
</div> -->
                   </div>      
                  <div class="contact-inner">
                    <label for="contact_number" hidden>phone number</label>
                    <input  formControlName="contactPhone" id="contact_number" type="text"
                        placeholder="Phone Number*"  >
                        <div *ngIf="contactForm.get('contactPhone')?.invalid && contactForm.get('contactPhone')?.touched" style="font-size: 13px; color: #FF0000; font-style: italic; font-weight: 500;display: flex; ">
                          {{ contactPhoneError }}
                        </div>
                </div>               
                <div class="contact-inner contact-message">
                  <label for="contact_Message" hidden>Message</label>
                  <textarea name="contactMessage" formControlName="contactMessage" placeholder="How can we help you today?" maxlength="500" (input)="onMessageChange()"></textarea>
                  <h3 class="contact-limit text-right">Character(s) Remaining: <span id="contact_chars">{{ charsRemaining }}</span></h3>
                 <div class="col pt-lg-4 pt-2">
                    <!-- Add ngClass to toggle the 'valid-form' class when the form is valid -->
                    <button type="submit" id="contact-form" class="contact_button" [ngClass]="{'valid-form': contactForm.valid, 'invalid-form': !contactForm.valid}"
                      [disabled]="!contactForm.valid">
                      Submit
                    </button>
                  </div>
                  </div>
            </form>
            <div class="thank-you-pop" *ngIf="showThankYouPopUp" id="thank-you-pop" class="custom-popup">
               <div class="popup-content">
<img src="../../../assets/images/contact/success.png" alt="Success" />
<h1>Thank You!</h1>
<p>We have received your request. Our team will reach out to you soon.</p>
</div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="contact-us-wrap-one">
            <h1 class="heading">
              We Love To Hear From You.
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--====================  Conact us Section End  ====================-->
</div>


        <!-- CSS For branches of offices -->

<!-- Our branches of offices -->


<section class="ouroffices_main">
<div class="container-fluid  mt-5">
<div class="pt-5 text-center">
<div class="row">
  <h1 class="office-title text-white pt-5">Our Branch Offices</h1>

<main class="page-content">


      <!-- <div class="content">
        <div class="title fifthheading text-white">USA, CONNECTICUT</div>
        <p class="copy"><p>21 State Street, Waterbury,  CT - 06702 </p>
             <p><i class="fa fa-phone" style="font-size:24px"></i>&nbsp;1-855-217-4637</p>
             <p><i class="fa fa-envelope"></i>&nbsp; info&#64;mitresource.com</p>
      </div> -->
    <div class="contactCards" >
    <figure class="snip1477 card2" (mouseenter)="addHover($event)" 
    (mouseleave)="removeHover($event)" style=" background-image: url('../../../assets/images/contact/connecticut.png');
    background-size: cover;
    background-repeat: no-repeat;">
      <!-- <img  alt="sample38" /> -->
      <div class="title">
        <div>
          <h2>USA</h2>
          <h6>CONNECTICUT</h6>
        </div>
      </div>
      <figcaption>
        <p>21 State Street, Waterbury,  CT - 06702</p>
        <p><i class="fa fa-phone" style="font-size:24px"></i>&nbsp;1-855-217-4637</p>
          <p><i class="fa fa-envelope"></i>&nbsp; info&#64;mitresource.com</p>
      </figcaption>
    
    </figure>
  </div>


  <div class="contactCards">
      <!-- <div class="content">
      <div class="title fifthheading text-white">CANADA</div>
        <p class="copy"><p>51 -5811  122 Street, Surrey BC V3X3N5</p>
             <p><i class="fa fa-phone" style="font-size:24px"></i>&nbsp;1-855-217-4637</p>
             <p><i class="fa fa-envelope"></i>&nbsp; magantiitcanada&#64;mitresource.com</p>
      </div> -->
    <figure class="snip1477 card2" (mouseenter)="addHover($event)" 
    (mouseleave)="removeHover($event)" style=" background-image: url('../../../assets/images/contact/canada.jpg');
    background-size: cover;
    background-repeat: no-repeat;">
     
      <div class="title">
        <div>
          <h2>CANADA</h2>
          <h6>Surrey BC</h6>
        </div>
      </div>
      <figcaption>
        <p>21 State Street, Waterbury,  CT - 06702</p>
        <p><i class="fa fa-phone" ></i>&nbsp;1-855-217-4637</p>
          <p><i class="fa fa-envelope"></i>&nbsp; magantiitcanada&#64;mitresource.com</p>
      </figcaption>
     
    </figure>
  </div>


  <div class="contactCards">
    <figure class="snip1477 card2" (mouseenter)="addHover($event)" 
    (mouseleave)="removeHover($event)" style=" background-image: url('../../../assets/images/contact/australia.jpg');
    background-size: cover;
    background-repeat: no-repeat;">
     
      <div class="title">
        <div>
          <h2>AUSTRALIA</h2>
          <h6>Chadstone Vic</h6>
        </div>
      </div>
      <figcaption>
        <p>35 Carramar Street, Chadstone Vic 3148</p>
        <p><i class="fa fa-phone" ></i>&nbsp;1-855-217-4637</p>
          <p><i class="fa fa-envelope"></i>&nbsp; info_aus&#64;mitresource.com</p>
      </figcaption>
  
    </figure>

</div>
</main>

<main class="page-content1">

<div class="contactCards">
  <figure class="snip1477 card2" (mouseenter)="addHover($event)" 
  (mouseleave)="removeHover($event)" style=" background-image: url('../../../assets/images/contact/hyderabad.webp');
  background-size: cover;
  background-repeat: no-repeat;">
   
    <div class="title">
      <div>
        <h2>INDIA</h2>
        <h6>HYDERABAD</h6>
      </div>
    </div>
    <figcaption>
      <p>H No 6-3-661/10/1&10/2 
        Flat NO:601  Sangeeth Nagar, Somajiguda, Hyderabad-500082, Telangana, INDIA</p>
      <p><i class="fa fa-phone" ></i>&nbsp;+91 9959372188</p>
        <p><i class="fa fa-envelope"></i>&nbsp; info&#64;mitresource.com</p>
    </figcaption>

  </figure>

</div>
<div class="contactCards">
<figure class="snip1477 card2" (mouseenter)="addHover($event)" 
(mouseleave)="removeHover($event)" style=" background-image: url('../../../assets/images/contact/vijayawada.png');
background-size: cover;
background-repeat: no-repeat;">
 
  <div class="title">
    <div>
      <h2>INDIA</h2>
      <h6>VIJAYAWADA</h6>
    </div>
  </div>
  <figcaption>
    <p> D.NO: 23-19 , Anand Square Building, Saipuram Colony , Gollapudi-521225, Andhra Pradesh, INDIA </p>
    <p><i class="fa fa-phone" ></i>&nbsp;+91 9959372188</p>
      <p><i class="fa fa-envelope"></i>&nbsp; info&#64;mitresource.com</p>
  </figcaption>

</figure>

</div>
<div class="contactCards">
<figure class="snip1477 card2" (mouseenter)="addHover($event)" 
(mouseleave)="removeHover($event)" style=" background-image: url('../../../assets/images/contact/Eluru.jpg');
background-size: cover;
background-repeat: no-repeat;">
 
  <div class="title">
    <div>
      <h2>INDIA</h2>
      <h6>ELURU</h6>
    </div>
  </div>
  <figcaption>
    <p>D-NO: 23A-2-29 Panugantivari Street ,
      R.R.Peta, ELURU-534002
      Andhra Pradesh, INDIA</p>
    <p><i class="fa fa-phone" ></i>&nbsp;+91 9959372188</p>
      <p><i class="fa fa-envelope"></i>&nbsp; info&#64;mitresource.com</p>
  </figcaption>

</figure>

</div>
   
</main>
</div>
</div>
</div>
</section>






